"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealLostReason = void 0;
var DealLostReason;
(function (DealLostReason) {
    DealLostReason["BudgetConstraints"] = "Budgetbeperkingen - Wil niet financieren";
    DealLostReason["CompetitionPrice"] = "Concurrentie - Prijs";
    DealLostReason["CompetitionOtherProduct"] = "Concurrentie - Ander product";
    DealLostReason["CompetitionOther"] = "Concurrentie - Anders";
    DealLostReason["PostponingLongTerm"] = "Doorschuiven voor langere termijn";
    DealLostReason["NoFinancingApproval"] = "Geen akkoord financiering";
    DealLostReason["NoFinancingPermit"] = "Geen financiering/vergunning verkregen";
    DealLostReason["AgreementComparableProduct"] = "Akkoord met een vergelijkbaar product";
    DealLostReason["ReasonUnclearNoReach"] = "Reden niet duidelijk - Niet meer te bereiken";
    DealLostReason["NotSatisfiedService"] = "Niet tevreden met dienstverlening";
    DealLostReason["PricePaybackTooLong"] = "Prijs - Terugverdientijd te lang";
    DealLostReason["PriceInvestmentHigh"] = "Prijs - Vindt de investering te hoog";
    DealLostReason["InstallationTookLong"] = "Installatie liet te lang op zich wachten";
    DealLostReason["NotFeasible"] = "Niet uitvoerbaar";
    DealLostReason["Other"] = "Anders";
})(DealLostReason = exports.DealLostReason || (exports.DealLostReason = {}));
